import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '@': 'editingChangeImpact',
  },
  subqueries: {
    editingChangeImpact: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'changeImpactId',
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      quantity: 1,
      subqueries: {
        currentPersonaIds: {
          ref: {
            attr: 'attr:ent#!change_impact_personas#!change_impact_persona:!change_impact',
          },
          target: 'ent:!change_impact_personas:!change_impact_persona',
          selection: {
            '@.': ['!persona', { ref: { entity: '!persona' } }],
          },
        },
      },
      selection: {
        '{}': {
          name: 'Edit Change Impact',
          type: 'details',
          watch: {
            '[]': [
              {
                '{}': {
                  alias: 'save.change.impact',
                },
              },
            ],
          },
          content: {
            '{}': {
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Impact ID',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!code',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'targetGoLiveDate',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Date',
                              type: 'DATE',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!target_go_live_date',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Change Impact Title',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!name',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'descr',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: "What's Changing Summary",
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!descr',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'currentState',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Current State',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!current_state',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'futureState',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Future State',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!future_state',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'workstream',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Workstream',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!change_impact_functional_area',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!functional_area',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'phase',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Phase/Epic',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_phase',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!phase',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'sprint',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Sprint',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_sprint',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!sprint',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'topic',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Topic',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!topic',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'impactedGroups',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Department',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_department',
                                  isMultiselect: true,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!impacted_groups',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'degreeOfChange',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Degree of Change',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!degree_of_change',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'areaOfConcern',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Area of Concern',
                              type: 'BOOL',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!area_of_concern',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'keyBenefit',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Key Benefit',
                              type: 'BOOL',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!key_benefit',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'type',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Type',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_type',
                                  isMultiselect: true,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!type',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'personas',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Personas',
                              type: {
                                '{}': {
                                  entityId: 'ent:!personas:!persona',
                                  dimensionId: 'dim::!personas',
                                  isMultiselect: true,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        if: [
                          [
                            {
                              '>': [{ '#': { '@': 'currentPersonaIds' } }, 0],
                            },
                            {
                              '{}': {
                                'ent:!personas:!persona': {
                                  '@': 'currentPersonaIds',
                                },
                              },
                            },
                          ],
                          null,
                        ],
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'anticipatedResponseOfChange',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Anticipated Response of Change',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!change_impact_anticipated_response',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!anticipated_response_of_change',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'validationStatus',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Validation Status',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!change_impact_validation_status',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!validation_status',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'communicationsNeeded',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Communications Needed',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_yes_no_na',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!communications_needed',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'communicationsNotes',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Communications Notes',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!communications_notes',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'trainingImplications',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Training Implications',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_yes_no_na',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!training_implications',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'trainingImplicationsNotes',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Training Implications Notes',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!training_implications_notes',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'userStory',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'User Story',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!user_story',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'otherComments',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Other Comments',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!other_comments',
                      },
                    },
                  },
                ],
              },
              onSave: {
                '{}': {
                  action: {
                    '{}': {
                      alias: 'save.change.impact',
                    },
                  },
                  variables: {
                    '{}': {
                      changeImpactId: {
                        '@.': '!id',
                      },
                      changeImpactCode: '${field:code}',
                      changeImpactName: '${field:name}',
                      changeImpactType: '${field:type}',
                      changeImpactPhase: '${field:phase}',
                      changeImpactTopic: '${field:topic}',
                      changeImpactSprint: '${field:sprint}',
                      changeImpactUserStory: '${field:userStory}',
                      changeImpactKeyBenefit: '${field:keyBenefit}',
                      changeImpactDescription: '${field:descr}',
                      changeImpactFutureState: '${field:futureState}',
                      changeImpactCurrentState: '${field:currentState}',
                      changeImpactAreaOfConcern: '${field:areaOfConcern}',
                      changeImpactOtherComments: '${field:otherComments}',
                      changeImpactDegreeOfChange: '${field:degreeOfChange}',
                      changeImpactFunctionalArea: '${field:workstream}',
                      changeImpactImpactedGroups: '${field:impactedGroups}',
                      changeImpactPersonas: '${field:personas}',
                      changeImpactTargetGoLiveDate: '${field:targetGoLiveDate}',
                      changeImpactValidationStatus: '${field:validationStatus}',
                      changeImpactCommunicationsNotes:
                        '${field:communicationsNotes}',
                      changeImpactCommunicationsNeeded:
                        '${field:communicationsNeeded}',
                      changeImpactTrainingImplications:
                        '${field:trainingImplications}',
                      changeImpactTrainingImplicationsNotes:
                        '${field:trainingImplicationsNotes}',
                      changeImpactAnticipatedResponseOfChange:
                        '${field:anticipatedResponseOfChange}',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
